/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, shape, string, func, array, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CachedIcon from '@material-ui/icons/Cached';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';

const styles = (theme) => ({
    subscriptionContainer: {
        border: `1px solid ${(theme.palette.grey8)}`,
        borderRadius: '4px',
        padding: '9px 14px',
        [theme.breakpoints.down('sm')]: {
            padding: '9px 14px 9px 0',
        },
    },
    marginBottom15: {
        marginBottom: '15px',
    },
    subContainer: {
        display: 'flex',
        '& > div': {
            margin: 'auto',
        },
    },
    icon: {
        color: theme?.palette?.cms?.icon,
        margin: 'auto',
    },
    borderRight1: {
        borderRight: `1px solid ${(theme.palette.grey8)}`,
    },
    marginTopBottom10: {
        margin: '10px 0px',
    },
    subcriptionContent: {
        '& p': {
            fontSize: '16px',
            margin: '4px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '15px',
            },
        },
    },
    fontSize67: {
        fontSize: '67px',
        [theme.breakpoints.down('md')]: {
            fontSize: '45px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '35px',
        },
    },
    fontSize34: {
        fontSize: '34px',
    },
    subcriptionCheckBoxContent: {
        fontSize: '14px',
        '& b': {
            fontSize: '16px',
            display: 'block',
        },
    },
    checkbox: {
        color: theme.palette.cms?.checkbox,
        padding: '20px',
        '&$checked': {
            color: theme.palette.cms?.checkbox,
            '&:hover': {
                backgroundColor: theme.palette.colorNeutral20,
            },
        },
        '&:hover': {
            backgroundColor: theme.palette.colorNeutral20,
        },
    },
    checked: {
        color: theme.palette.cms?.checkbox,
        '&$checked': {
            color: theme.palette.cms?.checkbox,
            '&:hover': {
                backgroundColor: theme.palette.colorNeutral20,
            },
        },
    },
});

class GraphqlSubscriptionContainer extends PureComponent {
    renderBasicSubscription = (classes, subscriptionDetailsFrequencyValue, subscriptionDetailsDurationValue, subscriptionCheckbox, triggerSubscriptionCheck) => (
        <>
            <Grid item xs={2} className={classes.subContainer}>
                <CachedIcon className={`${classes.icon} ${classes.fontSize67}`} />
            </Grid>
            <Grid item xs={4} className={classes.subContainer}>
                <div className={classes.subcriptionContent}>
                    <Typography variant="body1"><b>Frequency:</b> {subscriptionDetailsFrequencyValue === '4.Four Week' ? 'Every 4 weeks' : subscriptionDetailsFrequencyValue} </Typography>
                    <Typography variant="body1"><b>Duration:</b>  {subscriptionDetailsDurationValue} </Typography>
                </div>
                <Typography variant="span" className={`${classes.borderRight1} ${classes.marginTopBottom10}`} />
            </Grid>
            <Grid item xs={6} className={classes.subContainer}>
                <Checkbox
                    id="chk-monthly-subscription"
                    data-test="pdp-check-monthly-subscription"
                    name="monthlySubscriptionChecked"
                    checked={subscriptionCheckbox}
                    onChange={triggerSubscriptionCheck}
                    classes={{
                        root: classes.checkbox,
                        checked: classes.checked,
                    }}
                />
                <Typography variant="body1" className={classes.subcriptionCheckBoxContent}><b>Make this a recurring Shipment</b> Start a subscription and have it delivered monthly.</Typography>
            </Grid>
        </>
    );

    renderDiscoverySubscription = (classes, subscriptionDetailsFrequencyValue, subscriptionDetailsDurationValue) => (
        <>
            <Grid item xs={3} className={`${classes.subContainer} ${classes.borderRight1}`}>
                <div className={classes.subcriptionContent}>
                    <Typography variant="body1"><b>Subscription</b></Typography>
                </div>
            </Grid>
            <Grid item xs={1} className={classes.subContainer}>
                <CachedIcon className={`${classes.icon} ${classes.fontSize34}`} />
            </Grid>
            <Grid item xs={8} className={classes.subContainer}>
                <div className={classes.subcriptionContent}>
                    <Typography variant="body1"><b>Frequency:</b> {subscriptionDetailsFrequencyValue === '4.Four Week' ? 'Every 4 weeks' : subscriptionDetailsFrequencyValue}</Typography>
                </div>
                <div className={classes.subcriptionContent}>
                    <Typography variant="body1"><b>Duration:</b> {subscriptionDetailsDurationValue}</Typography>
                </div>
            </Grid>
        </>
    )

    render() {
        const {
            classes,
            subscriptionDetails,
            subscription,
            triggerSubscriptionCheck,
        } = this.props;
        const {
            subscriptionDuration,
            subscriptionFrequency,
        } = subscriptionDetails;
        const {
            isTypeDiscovery,
            subscriptionCheckbox,
        } = subscription;
        return (
            <Grid item xs={12} sm={12} md={12} className={classes.marginBottom15}>
                <Grid container className={classes.subscriptionContainer}>
                    {(isTypeDiscovery)
                        ? this.renderDiscoverySubscription(classes, subscriptionFrequency, subscriptionDuration)
                        : this.renderBasicSubscription(classes, subscriptionFrequency, subscriptionDuration, subscriptionCheckbox, triggerSubscriptionCheck)}
                </Grid>
            </Grid>
        );
    }
}

GraphqlSubscriptionContainer.propTypes = {
    classes: object.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string.isRequired,
        subscriptionDuration: string.isRequired,
        subscriptionFrequency: string.isRequired,
        subscriptionDurationKey: string.isRequired,
    }).isRequired,
    subscription: shape({
        subscriptionKey: array.isRequired,
        subscriptionIndefinite: string.isRequired,
        subscriptionType: array.isRequired,
        implementProductSubscription: bool.isRequired,
        viewSubscription: bool.isRequired,
        isTypeDiscovery: bool.isRequired,
        subscriptionCheckbox: bool.isRequired,
    }).isRequired,
    triggerSubscriptionCheck: func.isRequired,
};

export default withStyles(styles, { withTheme: true })(GraphqlSubscriptionContainer);
